import React from "react";
import { isNonEmptyArray } from "../../../../../../common/utils";
import styles from "./Row.module.css";

const HeaderRow = ({ headers }) => (
	<div className={styles.headerRow}>
		{isNonEmptyArray(headers) &&
			headers.map((header) => (
				<div key={header.name} className={styles[header.className]}>
					{header.name}
				</div>
			))}
	</div>
);

export default HeaderRow;
